import React from "react";
import { createPluggable } from "pluggable-react";
import Status from "../Status/Status";

export interface EmptyStatusProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  variant?: "default" | "compact";
}

const DefaultEmptyStatus = ({ 
  children, 
  variant = "default", 
  className,
  ...props 
}: EmptyStatusProps) => {
  return (
    <Status variant={variant} className={className} {...props}>
      {children}
    </Status>
  );
};

const EmptyStatus = createPluggable<EmptyStatusProps>("deci.emptyStatus", DefaultEmptyStatus);

export default Object.assign(EmptyStatus, {
  Graphic: Status.Graphic,
  Title: Status.Title,
  Content: Status.Content,
});
